export default __webpack_public_path__ + "static/panicked-f0306716898b303831eb71f1b77b04f7.svg";